<!--
  File name: FBNERView.vue
  Program Description:
    - This component is used for viewing the FBNER
    - Data is fetched from fbnerMixin
-->
<template>
  <v-container class="pa-0">
    <v-expansion-panels
      v-model="panels"
      flat
      multiple
      hover
      max="8"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Summary
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="formItem.organization"
                dense
                outlined
                disabled
                label="PIC"
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="formItem.dbnNumber"
                dense
                outlined
                disabled
                label="DBN Number"
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <DateComponent
                :value="formItem.dateOfOccurrence"
                :no-title="false"
                :persistent-placeholder="false"
                dense
                disabled
                outlined
                readonly
                whole-month
                placeholder=""
                label="Date of Occurrence"
                date-class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="formItem.dateOfDiscovery"
                dense
                outlined
                disabled
                label="Date of Discovery"
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="formItem.dateOfNotification"
                dense
                outlined
                disabled
                label="Date of Notification of the Commission"
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                :value="formItem.timeOfOccurrence || `-`"
                dense
                disabled
                outlined
                label="Time of Occurrence"
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                :value="formItem.timeOfDiscovery || `-`"
                disabled
                outlined
                label="Time of Discovery"
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="pt-0"
              cols="4"
            >
              <span class="pl-3 gray--text font-weight-bold">Exemption to DS Notification</span>
              <RadioButton
                :value="formItem.exemptionToDSNotification"
                dense
                :can-edit="false"
                :field-class="'font-weight-bold text-body-1'"
                :is-row="true"
                :options="exemptionOptions"
              />
            </v-col>
          </v-row>
          <v-row v-if="formItem.exemptionToDSNotification === 'Yes'">
            <v-col>
              <v-textarea
                :value="formItem.justificationForExemption || '-'"
                dense
                disabled
                readonly
                outlined
                rows="4"
                label="Justification for exemption"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="pt-0"
              cols="4"
            >
              <span class="pl-3 gray--text font-weight-bold">Notified Data Subject</span>
              <RadioButton
                :value="formItem.notifiedDataSubject"
                :can-edit="false"
                :options="notifiedDataSubjOptions"
                field-class="font-weight-bold text-body-1"
                is-row
                dense
              />
            </v-col>
          </v-row>
          <v-row v-show="formItem.notifiedDataSubject === 'Yes' || isNotified">
            <v-col cols="4">
              <span class="pl-3  gray--text font-weight-bold">Date of DS Notification</span>
              <DateComponent
                :value="formItem.dateOfDSNotification"
                :no-title="false"
                :persistent-placeholder="false"
                dense
                disabled
                outlined
                readonly
                whole-month
                placeholder=""
                date-class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="4">
              <span class="pl-3 gray--text font-weight-bold">Mode of DS Notification</span>
              <v-textarea
                :value="formItem.modeOfDSNotification || `-`"
                dense
                readonly
                disabled
                rows="4"
                outlined
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
            <v-col cols="4">
              <span class="pl-3 gray--text font-weight-bold">Assistance Provided to DS</span>
              <v-textarea
                :value="formItem.assistanceProvided || `-`"
                dense
                readonly
                outlined
                rows="4"
                disabled
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row v-show="formItem.notifiedDataSubject === 'No'">
            <v-col cols="4">
              <v-textarea
                label="Reason for not notifying Data Subject"
                :value="formItem.reasonNotNotifiedDataSubject || `-`"
                dense
                rows="4"
                outlined
                disabled
                readonly
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="pl-3  gray--text font-weight-bold">Date of submission of Final/Full Breach Report</span>
              <v-text-field
                dense
                :value="formItem.dateOfSubmission || `-`"
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="pl-3 gray--text font-weight-bold">Registration</span>
              <RadioButton
                dense
                :value="formItem.registration "
                :can-edit="false"
                :field-class="'font-weight-bold text-body-1'"
                :is-row="true"
                :options="registrationOptions"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="pl-3 gray--text font-weight-bold">Incident Involves Public Interests?</span>
              <RadioButton
                dense
                :value="formItem.isIncidentInvolve "
                :can-edit="false"
                :field-class="'font-weight-bold text-body-1'"
                :is-row="true"
                :options="isIncidentInvolveOptions"
                @change="formItem.incidentInvolve = null"
              />
            </v-col>
          </v-row>
          <v-row v-show="formItem.isIncidentInvolve === 'Yes' || formItem.incidentInvolve && formItem.incidentInvolve.length > 0">
            <v-col cols="8">
              <span class="gray--text font-weight-bold text-h6">Incident involves public interest</span>
              <v-checkbox
                :id="`checkbox-incident-1`"
                v-model="formItem.incidentInvolve"
                multiple
                disabled
                class="font-weight-bold text-body-1 mt-3"
                label="The breach would likely affect national security, public safety, public order, or public health"
                value="The breach would likely affect national security, public safety, public order, or public health"
                dense
              />
              <v-checkbox
                :id="`checkbox-incident-2`"
                v-model="formItem.incidentInvolve"
                multiple
                disabled
                class="font-weight-bold text-body-1 "
                label="It involves personal data of vulnerable groups or pose imminent danger to the same"
                value="It involves personal data of vulnerable groups or pose imminent danger to the same"
                dense
              />
              <v-checkbox
                :id="`checkbox-incident-3`"
                v-model="formItem.incidentInvolve"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="News of the data breach has been reported and circulated in tri-media or social media, and the breach will likely give rise to a real risk of serious harm and the breach will likely give rise to a real risk to the rights and freedoms of data subjects"
                value="News of the data breach has been reported and circulated in tri-media or social media, and the breach will likely give rise to a real risk of serious harm and the breach will likely give rise to a real risk to the rights and freedoms of data subjects"
                dense
              />
              <v-checkbox
                :id="`checkbox-incident-4`"
                v-model="formItem.incidentInvolve"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="Personal data of at least one hundred (100) individuals were affected"
                value="Personal data of at least one hundred (100) individuals were affected"
                dense
              />
              <v-checkbox
                :id="`checkbox-incident-5`"
                v-model="formItem.incidentInvolve"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="The Quick Response Report recommends the notification of the breach to the OPC"
                value="The Quick Response Report recommends the notification of the breach to the OPC"
                dense
              />
            </v-col>
          </v-row>
          <span class="pl-3 gray--text font-weight-bold">Requests made by PIC/PIP</span>
          <v-row v-if="formItem.pbnefRequest && formItem.pbnefRequest.length">
            <v-col>
              <v-list-item
                v-for="request in formItem.pbnefRequest"
                :key="request.pbnefId"
              >
                <v-list-item-icon>
                  <v-chip
                    :class="request.evaluation === 'Denied' ? 'red red--text': 'green green--text'"
                    class="text--darken-1 lighten-5"
                  >
                    {{ request.evaluation }}
                  </v-chip>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ request.typeOfRequest.join(',') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-list-item-content>
              <v-list-item>
                <v-list-item-title class="ml-3 font-weight-bold text-body-1">
                  None
                </v-list-item-title>
              </v-list-item>
            </v-list-item-content>
          </v-row>
          <v-row v-if="formItem.specifyIfOthers">
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold ">Specify (if others)</span>
              <v-text-field
                v-model="formItem.specifyIfOthers"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.summary || `-`"
                dense
                disabled
                readonly
                outlined
                rows="4"
                label="Summary of the security incident"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Findings
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Timeliness of the Report</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="pt-0"
              cols="4"
            >
              <span class="pl-3 gray--text font-weight-bold">Notification Type</span>
              <RadioButton
                dense
                :value="formItem.typeOfNotification"
                :field-class="'font-weight-bold text-body-1 '"
                :is-row="true"
                :can-edit="false"
                :options="notificationTypeOptions"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <VAutocomplete
                v-model="formItem.requisites"
                :items="notifTypeItems"
                class="font-weight-bold text-body-1"
                label="Requisites"
                item-text="value"
                item-value="_id"
                disabled
                multiple
                outlined
                chips
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Timeliness</span>
              <v-text-field
                :value="formItem.timeliness || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Justified, if delayed</span>
              <v-text-field
                :value="formItem.justified || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksTimeliness || `-`"
                dense
                disabled
                readonly
                outlined
                rows="4"
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Nature of the Incident</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">General Cause</span>
              <LookUpSelect
                v-model="formItem.generalCause"
                dense
                flat
                solo
                class="font-weight-bold text-body-1"
                name="causeOfIncident"
                :allow-fetch="formItem.generalCause"
                :query="{'type': 'general'}"
                :item-text="'value'"
                append-icon=""
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Specific Cause</span>
              <LookUpSelect
                v-model="formItem.specificCause"
                dense
                flat
                solo
                disabled
                :additional-entries="[
                  {
                    _id: 'Others',
                    value: 'Others'
                  }
                ]"
                class="font-weight-bold text-body-1"
                name="causeOfIncident"
                :allow-fetch="formItem.generalCause"
                :item-text="'value'"
                :query="{'type': 'specific'}"
                append-icon=""
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksCause || `-`"
                dense
                disabled
                readonly
                outlined
                rows="4"
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="pl-3 gray--text font-weight-bold">Nature of Breach</span>
              <VAutocomplete
                v-model="formItem.natureOfBreach"
                :items="natureOfBreach"
                item-value="_id"
                item-text="value"
                class="font-weight-bold text-body-1"
                append-icon=""
                deletable-chips
                multiple
                disabled
                solo
                chips
                flat
              />
            </v-col>
          </v-row>
          <v-row class="mt-8">
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Number of affected data subjects/records</span>
              <v-text-field
                :value="formItem.numberOfAffectedDataRecords || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1 "
                oninput="validity.valid||(value=&quot;&quot;)"
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Types of Sensitive Personal Information</span>
              <v-textarea
                :value="formItem.sensitivePersonalInfo || `-`"
                rows="1"
                outlined
                readonly
                disabled
                solo
                flat
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksBreach || `-`"
                dense
                disabled
                readonly
                rows="4"
                outlined
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.otherInfo || `-`"
                dense
                label="Types of other information that may enable identity fraud"
                rows="4"
                outlined
                readonly
                disabled
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksOtherInfo || `-`"
                dense
                disabled
                readonly
                rows="4"
                outlined
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.consequences || `-`"
                dense
                outlined
                readonly
                disabled
                label="Likely consequences as provided by the PIC/PIP"
                rows="4"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksConsequences || `-`"
                dense
                rows="4"
                outlined
                readonly
                disabled
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="ml-n5 pb-10 pt-4">
              <h1 class="title primary--text">
                Compliance to the Data Privacy Act, itsIRR, NPC Circular 16-03, and other issuances of the NPC
              </h1>
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Organizational Security Measures</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.organizationalFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.organizationalReferences || `-`)"
                :items="referencesValue(formItem.organizationalReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.organizationalRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Physical Security Measures</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.physicalFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.physicalReferences || `-`)"
                :items="referencesValue(formItem.physicalReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.physicalRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Technical Security Measures</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.technicalFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.technicalReferences || `-`)"
                :items="referencesValue(formItem.technicalReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.technicalRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Measures taken to address the breach</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.addressFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.addressReferences || `-`)"
                :items="referencesValue(formItem.addressReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.addressRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Measures to secure/recover personal data</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.secureFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.secureReferences || `-`)"
                :items="referencesValue(formItem.secureReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.secureRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Actions to mitigate harm</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.mitigateFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.mitigateReferences || `-`)"
                :items="referencesValue(formItem.mitigateReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.mitigateRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Actions to inform data subjects</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.informFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.informReferences || `-`)"
                :items="referencesValue(formItem.informReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.informRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Measures to prevent recurrence of incidence</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-textarea
                :value="formItem.preventFindings || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Findings"
                disabled
                readonly
                outlined
              />
            </v-col>
            <v-col cols="4">
              <VAutocomplete
                :value="referencesValue(formItem.preventReferences || `-`)"
                :items="referencesValue(formItem.preventReferences || `-`)"
                class="font-weight-bold text-body-1 chips-wrap"
                label="References/Supporting Evidences"
                disabled
                outlined
                multiple
                chips
              />
            </v-col>
            <v-col cols="4">
              <v-textarea
                :value="formItem.preventRecommendations || `-`"
                dense
                rows="4"
                class="font-weight-bold text-body-1 cursor"
                label="Remarks"
                disabled
                readonly
                outlined
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Observations
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.summaryOfObservationsAndFindings || `-`"
                dense
                rows="4"
                disabled
                readonly
                label="Summary of observations and findings"
                outlined
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Recommendations
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Recommended Action</span>
              <VAutocomplete
                :value="formItem.recommendedAction"
                small-chips
                disabled
                solo
                flat
                append-icon=""
                multiple
                :items="[
                  'Issuance of Compliance Order',
                  'Investigation by CID',
                  'Closure',
                  'Compliance Check',
                  'For Administrative Fines'
                ]"
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksRecommendation || `-`"
                dense
                rows="4"
                disabled
                readonly
                outlined
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="gray--text font-weight-bold text-h6">Possible Violations of the DPA</span>
              <v-checkbox
                :id="`checkbox-sec-25`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1 mt-3"
                label="SEC. 25. Unauthorized Processing of Personal Information and Sensitive Personal Information"
                value="SEC. 25. Unauthorized Processing of Personal Information and Sensitive Personal Information"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-26`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 26. Accessing Personal Information and Sensitive Personal Information Due to Negligence"
                value="SEC. 26. Accessing Personal Information and Sensitive Personal Information Due to Negligence"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-27`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="SEC. 27. Improper Disposal of Personal Information and Sensitive Personal Information"
                value="SEC. 27. Improper Disposal of Personal Information and Sensitive Personal Information"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-28`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="SEC. 28. Processing of Personal Information and Sensitive Personal Information for Unauthorized Purposes"
                value="SEC. 28. Processing of Personal Information and Sensitive Personal Information for Unauthorized Purposes"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-29`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="SEC. 29. Unauthorized Access or Intentional Breach"
                value="SEC. 29. Unauthorized Access or Intentional Breach"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-30`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="SEC. 30. Concealment of Security Breaches Involving Sensitive Personal Information"
                value="SEC. 30. Concealment of Security Breaches Involving Sensitive Personal Information"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-31`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1"
                label="SEC. 31. Malicious Disclosure"
                value="SEC. 31. Malicious Disclosure"
                dense
              />
              <v-checkbox
                :id="`checkbox-sec-32`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 32. Unauthorized Disclosure"
                value="SEC. 32. Unauthorized Disclosure"
                dense
              />
              <v-checkbox
                :id="`checkbox-none`"
                v-model="formItem.possibleDpaViolation"
                multiple
                disabled
                class="font-weight-bold text-body-1 "
                label="None"
                value="None"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.remarksDpaViolation || `-`"
                dense
                disabled
                readonly
                rows="4"
                outlined
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Annex A (Contact Details of the PIC/PIP)
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Name of DPO</span>
              <v-text-field
                :value="formItem.nameOfDpo || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1 "
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Office Address</span>
              <v-text-field
                :value="formItem.officeAddress || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1 "
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Email Address</span>
              <v-text-field
                :value="formItem.emailAddress || `-`"
                dense
                disabled
                flat
                solo
                label="Name of DPO"
                class="font-weight-bold text-body-1 required-field"
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Mobile/Office Number</span>
              <v-text-field
                :value="formItem.mobileOrOfficeNumber || `-`"
                dense
                disabled
                solo
                flat
                label="Office Address"
                class="font-weight-bold text-body-1 required-field"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Name of Representative, if no appointed DPO</span>
              <v-text-field
                :value="formItem.representativeName || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Office Address</span>
              <v-text-field
                :value="formItem.representativeAddress || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Email Address</span>
              <v-text-field
                :value="formItem.representativeEmail || `-`"
                dense
                disabled
                solo
                flat
                label="Email Address"
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Mobile/Office Number</span>
              <v-text-field
                :value="formItem.representativeNumber || `-`"
                dense
                disabled
                solo
                flat
                label="Mobile/Office Number"
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Annex B (Compliance with Required Documents)
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row>
            <v-col class="pb-0">
              <h3
                class="gray--text font-weight-bold"
                style="font-size:18px"
              >
                Show Cause Order
              </h3>
              <RadioButton
                :value="hasShowCauseOrder"
                :options="exemptionOptions"
                :can-edit="false"
                dense
                is-row
                hide-details
                field-class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row v-show="hasShowCauseOrder === 'Yes'">
            <v-col>
              <v-textarea
                :value="formItem.showCauseReason || 'No Explanation.'"
                readonly
                outlined
                disabled
                dense
                rows="4"
                label="Explanation for non-submission of required documents (compliance with show cause order)"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Status of compliance</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="3"
              class="pt-0"
            >
              <v-col class="px-0 pt-0 mb-3">
                <h3
                  class="gray--text font-weight-bold"
                  style="font-size:18px"
                >
                  Documents required
                </h3>
              </v-col>
              <h3 class="black--text font-weight-bold text-body-1">
                Initial Report
              </h3>
            </v-col>

            <v-col
              cols="3"
              class="pt-0"
            >
              <v-col class="px-0 pt-0 mb-4">
                <h3
                  class="gray--text font-weight-bold"
                  style="font-size:18px"
                >
                  Legal Basis for Requirement
                </h3>
              </v-col>
              <v-row>
                <v-text-field
                  :value="'Section 17, NPC Circular 2016-03'"
                  dense
                  disabled
                  solo
                  flat
                  class="font-weight-bold text-body-1"
                />
              </v-row>
            </v-col>

            <v-col
              cols="3"
              class="pt-0"
            >
              <v-col class="px-0 pt-0 mb-4">
                <h3
                  class="gray--text font-weight-bold"
                  style="font-size:18px"
                >
                  Status of Compliance
                </h3>
              </v-col>
              <v-row>
                <v-text-field
                  :value="formItem.initialStatusOfCompliance || `-`"
                  dense
                  label="Status of compliance"
                  disabled
                  solo
                  flat
                  class="font-weight-bold text-body-1 "
                />
              </v-row>
            </v-col>
            <v-col
              cols="3"
              class="pt-0"
            >
              <v-col class="px-0 pt-0 mb-4">
                <h3
                  class="gray--text font-weight-bold"
                  style="font-size:18px"
                >
                  Date of compliance
                </h3>
              </v-col>
              <v-row>
                <DateComponent
                  :value="formItem.initialDateOfCompliance"
                  :persistent-placeholder="false"
                  :no-title="false"
                  dense
                  whole-month
                  disabled
                  readonly
                  outlined
                  placeholder=""
                  date-class="font-weight-bold text-body-1"
                />
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="3"
              class="pt-0"
            >
              <h3 class="black--text font-weight-bold text-body-1">
                Full Report
              </h3>
            </v-col>
            <v-col
              cols="3"
              class="pt-0"
            >
              <v-row>
                <v-text-field
                  :value="'Section 17, NPC Circular 2016-03'"
                  dense
                  disabled
                  solo
                  flat
                  class="font-weight-bold text-body-1"
                />
              </v-row>
            </v-col>
            <v-col
              cols="3"
              class="pt-0"
            >
              <v-row>
                <v-text-field
                  :value="formItem.fullStatusOfCompliance || `-`"
                  dense
                  label="Status of compliance"
                  disabled
                  solo
                  flat
                  class="font-weight-bold text-body-1 "
                />
              </v-row>
            </v-col>
            <v-col
              cols="3"
              class="pt-0"
            >
              <v-row>
                <DateComponent
                  :value="formItem.fullDateOfCompliance"
                  :no-title="false"
                  :persistent-placeholder="false"
                  dense
                  disabled
                  whole-month
                  readonly
                  outlined
                  placeholder=""
                  date-class="font-weight-bold text-body-1"
                />
              </v-row>
            </v-col>
          </v-row>

          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Documents Required</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Type of issuance</span>
              <v-text-field
                dense
                disabled
                solo
                :value="formItem.typeOfIssuance || `-`"
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Date of issuance</span>
              <v-text-field
                dense
                disabled
                solo
                :value="formItem.dateOfIssuance || `-`"
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <template
            v-for="(docRequired, idx) in formItem.docsArray"
          >
            <template>
              <v-row :key="`documents-row-top-${idx}`">
                <v-col
                  cols="6"
                >
                  <span class="pl-3 gray--text font-weight-bold">Document</span>
                  <v-text-field
                    :value="formItem.docsArray[idx].document || `-`"
                    dense
                    solo
                    flat
                    class="font-weight-bold text-body-1"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <span class="pl-3 gray--text font-weight-bold">Legal basis for Requirement</span>
                  <VAutocomplete
                    v-model="formItem.docsArray[idx].legalBasisForRequirement"
                    :items="legalBasisOptions"
                    class="font-weight-bold text-body-1"
                    append-icon=""
                    deletable-chips
                    multiple
                    disabled
                    solo
                    small-chips
                    flat
                  />
                </v-col>
              </v-row>
              <v-row :key="`documents-row-bottom-${idx}`">
                <v-col cols="6">
                  <span class="pl-3 gray--text font-weight-bold">Status of compliance</span>
                  <v-text-field
                    :value="formItem.docsArray[idx].statusOfCompliance || `-`"
                    dense
                    solo
                    flat
                    class="font-weight-bold text-body-1"
                  />
                </v-col>
                <v-col cols="6">
                  <span class="pl-3 gray--text font-weight-bold">Date of compliance</span>
                  <DateComponent
                    :value="formItem.docsArray[idx].dateOfCompliance"
                    :no-title="false"
                    :persistent-placeholder="false"
                    dense
                    whole-month
                    outlined
                    readonly
                    placeholder=""
                    date-class="font-weight-bold text-body-1"
                  />
                </v-col>
              </v-row>
            </template>
          </template>
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Recommendation</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Recommendation</span>
              <v-combobox
                v-model="formItem.overallRecommendation"
                dense
                disabled
                class="font-weight-bold text-body-1 required-field"
                multiple
                chips
                small-chips
                solo
                flat
                append-icon=""
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    class="mt-2"
                    small
                  >
                    {{ item }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="6">
              <span class="pl-3 gray--text font-weight-bold">Over all level of compliance</span>
              <v-text-field
                :value="formItem.overall || `-`"
                dense
                disabled
                solo
                flat
                class="font-weight-bold text-body-1"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                :value="formItem.overallRemarks || `-`"
                dense
                rows="4"
                disabled
                readonly
                outlined
                label="Remarks"
                class="font-weight-bold text-body-1 cursor"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Annex C (Elements of Violations under the Data Privacy Act)
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row class="pb-2">
            <v-col class="primary--text">
              <h2>Violations</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-25`"
                v-model="formItem.violations"
                multiple
                disabled
                class="font-weight-bold text-body-1 mt-3"
                label="SEC. 25. Unauthorized Processing of Personal Information and Sensitive Personal Information"
                value="SEC. 25. Unauthorized Processing of Personal Information and Sensitive Personal Information"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 25. Unauthorized Processing of Personal Information and Sensitive Personal Information')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-1`"
                    v-model="formItem.specifyIfSec25"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="There is personal information (PI)"
                    value="There is personal information (PI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-2`"
                    v-model="formItem.specifyIfSec25"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is sensitive personal information (SPI)"
                    value="There is sensitive personal information (SPI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-3`"
                    v-model="formItem.specifyIfSec25"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is processing of PI/SPI"
                    value="There is processing of PI/SPI"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-4`"
                    v-model="formItem.specifyIfSec25"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The processing of PI/SPI was without the consent of the data subject, or not authorized under the DPA or any existing law"
                    value="The processing of PI/SPI was without the consent of the data subject, or not authorized under the DPA or any existing law"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-26`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 26. Accessing Personal Information and Sensitive Personal Information Due to Negligence"
                value="SEC. 26. Accessing Personal Information and Sensitive Personal Information Due to Negligence"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 26. Accessing Personal Information and Sensitive Personal Information Due to Negligence')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-5`"
                    v-model="formItem.specifyIfSec26"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is personal information (PI)"
                    value="There is personal information (PI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-6`"
                    v-model="formItem.specifyIfSec26"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is sensitive personal information (SPI)"
                    value="There is sensitive personal information (SPI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-7`"
                    v-model="formItem.specifyIfSec26"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The PI/SPI was accessed"
                    value="The PI/SPI was accessed"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-8`"
                    v-model="formItem.specifyIfSec26"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The access was not authorized under the DPA or any existing law"
                    value="The access was not authorized under the DPA or any existing law"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-9`"
                    v-model="formItem.specifyIfSec26"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The unauthorized access was due to the negligence of any person"
                    value="The unauthorized access was due to the negligence of any person"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-27`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 27. Improper Disposal of Personal Information and Sensitive Personal Information"
                value="SEC. 27. Improper Disposal of Personal Information and Sensitive Personal Information"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 27. Improper Disposal of Personal Information and Sensitive Personal Information')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-10`"
                    v-model="formItem.specifyIfSec27"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is personal information (PI)"
                    value="There is personal information (PI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-11`"
                    v-model="formItem.specifyIfSec27"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is sensitive personal information (SPI)"
                    value="There is sensitive personal information (SPI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-12`"
                    v-model="formItem.specifyIfSec27"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The PI/SPI was disposed, discarded, or abandoned"
                    value="The PI/SPI was disposed, discarded, or abandoned"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-13`"
                    v-model="formItem.specifyIfSec27"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The place of disposal is an area accessible to the public or the PI/SPI was placed in its container for trash collection"
                    value="The place of disposal is an area accessible to the public or the PI/SPI was placed in its container for trash collection"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-28`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 28. Processing of Personal Information and Sensitive Personal Information for Unauthorized Purposes"
                value="SEC. 28. Processing of Personal Information and Sensitive Personal Information for Unauthorized Purposes"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 28. Processing of Personal Information and Sensitive Personal Information for Unauthorized Purposes')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-14`"
                    v-model="formItem.specifyIfSec28"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is personal information (PI)"
                    value="There is personal information (PI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-15`"
                    v-model="formItem.specifyIfSec28"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is sensitive personal information (SPI)"
                    value="There is sensitive personal information (SPI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-16`"
                    v-model="formItem.specifyIfSec28"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="There is processing of PI/SPI"
                    value="There is processing of PI/SPI"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-17`"
                    v-model="formItem.specifyIfSec28"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The person processing the PI/SPI was initially authorized to process the same"
                    value="The person processing the PI/SPI was initially authorized to process the same"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-18`"
                    v-model="formItem.specifyIfSec28"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The processing is for a purpose not authorized by the data subject, under this Act or under existing laws"
                    value="The processing is for a purpose not authorized by the data subject, under this Act or under existing laws"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-29`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 29. Unauthorized Access or Intentional Breach"
                value="SEC. 29. Unauthorized Access or Intentional Breach"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 29. Unauthorized Access or Intentional Breach')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-19`"
                    v-model="formItem.specifyIfSec29"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="There is a system where personal and sensitive personal information is stored"
                    value="There is a system where personal and sensitive personal information is stored"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-20`"
                    v-model="formItem.specifyIfSec29"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="A person breaks into the system"
                    value="A person breaks into the system"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-21`"
                    v-model="formItem.specifyIfSec29"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The breaking of the system was done knowingly and unlawfully, or violating data confidentiality and security data systems"
                    value="The breaking of the system was done knowingly and unlawfully, or violating data confidentiality and security data systems"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-30`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 30. Concealment of Security Breaches Involving Sensitive Personal Information"
                value="SEC. 30. Concealment of Security Breaches Involving Sensitive Personal Information"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 30. Concealment of Security Breaches Involving Sensitive Personal Information')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-22`"
                    v-model="formItem.specifyIfSec30"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="A personal data breach occurred"
                    value="A personal data breach occurred"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-23`"
                    v-model="formItem.specifyIfSec30"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The breach is required to be notified to the NPC"
                    value="The breach is required to be notified to the NPC"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-24`"
                    v-model="formItem.specifyIfSec30"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The person knows of the breach and the obligation to notify the NPC"
                    value="The person knows of the breach and the obligation to notify the NPC"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-25`"
                    v-model="formItem.specifyIfSec30"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The fact of such breach was not notified to the NPC"
                    value="The fact of such breach was not notified to the NPC"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-31`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 31. Malicious Disclosure"
                value="SEC. 31. Malicious Disclosure"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 31. Malicious Disclosure')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-26`"
                    v-model="formItem.specifyIfSec31"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The offender is a personal information controller or personal information processor or any of its officials, employees or agents"
                    value="The offender is a personal information controller or personal information processor or any of its officials, employees or agents"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-27`"
                    v-model="formItem.specifyIfSec31"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The offender disclosed unwarranted or false information"
                    value="The offender disclosed unwarranted or false information"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-28`"
                    v-model="formItem.specifyIfSec31"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The unwarranted or false information refers to any personal information (PI) or sensitive personal information (SPI)"
                    value="The unwarranted or false information refers to any personal information (PI) or sensitive personal information (SPI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-29`"
                    v-model="formItem.specifyIfSec31"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The PI/SPI was obtained by him/her"
                    value="The PI/SPI was obtained by him/her"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-30`"
                    v-model="formItem.specifyIfSec31"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The disclosure was attended by malice or bad faith"
                    value="The disclosure was attended by malice or bad faith"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                :id="`checkbox-sec-32`"
                v-model="formItem.violations"
                disabled
                class="font-weight-bold text-body-1 "
                label="SEC. 32. Unauthorized Disclosure"
                value="SEC. 32. Unauthorized Disclosure"
                dense
              />
              <template v-if="formItem.violations.includes('SEC. 32. Unauthorized Disclosure')">
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-31`"
                    v-model="formItem.specifyIfSec32"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The offender is a personal information controller or personal information processor or any of its officials, employees or agents"
                    value="The offender is a personal information controller or personal information processor or any of its officials, employees or agents"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-32`"
                    v-model="formItem.specifyIfSec32"
                    class="font-weight-bold  "
                    multiple
                    disabled
                    label="The information refers to any personal information (PI) or sensitive personal information (SPI)"
                    value="The information refers to any personal information (PI) or sensitive personal information (SPI)"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-33`"
                    v-model="formItem.specifyIfSec32"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The information is not unwarranted or false"
                    value="The information is not unwarranted or false"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-33`"
                    v-model="formItem.specifyIfSec32"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The PI/SPI was obtained by him/her"
                    value="The PI/SPI was obtained by him/her"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-34`"
                    v-model="formItem.specifyIfSec32"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The disclosure was without the consent of the data subject"
                    value="The disclosure was without the consent of the data subject"
                    dense
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-checkbox
                    :id="`subcheckbox-35`"
                    v-model="formItem.specifyIfSec32"
                    multiple
                    disabled
                    class="font-weight-bold  "
                    label="The disclosure was not attended by malice or bad faith"
                    value="The disclosure was not attended by malice or bad faith"
                    dense
                  />
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0">
          <h1 class="title primary--text">
            Annex D (Timeline of Actions Taken by the PIC/PIP and CMD)
          </h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <template>
            <template v-for="(action, idx) in formItem.actionTakenArray">
              <v-row :key="`actionTaken-row-bottom-${idx}`">
                <v-col>
                  <span class="pl-3 gray--text font-weight-bold">Action Taken</span>
                  <v-text-field
                    :value="formItem.actionTakenArray[idx].actionTaken || `-`"
                    outlined
                    dense
                    disabled
                    solo
                    flat
                    class="font-weight-bold text-body-1"
                  />
                </v-col>
                <v-col>
                  <span class="pl-3 gray--text font-weight-bold">Date</span>
                  <DateComponent
                    :value="formItem.actionTakenArray[idx].date"
                    :persistent-placeholder="false"
                    :no-title="false"
                    dense
                    disabled
                    whole-month
                    readonly
                    outlined
                    placeholder=""
                    date-class="font-weight-bold text-body-1"
                  />
                </v-col>
                <v-col>
                  <span class="pl-3 gray--text font-weight-bold">Timeliness</span>
                  <v-text-field
                    :value="formItem.actionTakenArray[idx].timeliness || `-` "
                    outlined
                    dense
                    solo
                    flat
                    disabled
                    class="font-weight-bold text-body-1"
                    append-icon=""
                  />
                </v-col>
              </v-row>
            </template>
            <template>
              <!-- <v-row>
          <v-col class="ml-n5 pb-10 pt-4">
            <h1 class="title primary--text">
              Signatories
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <span class="pl-3 gray--text font-weight-bold">Evaluated by</span>
            <v-text-field
              dense
              disabled
              solo
              :value="formItem.evaluatedBy && formItem.evaluatedBy.fullName || `-`"
              flat
              class="font-weight-bold text-body-1"
            />
          </v-col>
          <v-col cols="4">
            <span class="pl-3 gray--text font-weight-bold">Reviewed by</span>
            <v-text-field
              dense
              :value="(formItem.reviewedBy && formItem.reviewedBy.fullName) || `-`"
              disabled
              solo
              flat
              class="font-weight-bold text-body-1"
            />
          </v-col>
          <v-col cols="4">
            <span class="pl-3 gray--text font-weight-bold">Approved by</span>
            <v-text-field
              dense
              disabled
              solo
              :value="(formItem.approvedBy && formItem.approvedBy.fullName) || `-`"
              flat
              class="font-weight-bold text-body-1"
            />
          </v-col>
        </v-row> -->
              <template v-if="enableUpload">
                <v-row
                  v-if="canViewUploadHeader"
                  class="pb-2"
                >
                  <v-col class="primary--text">
                    <h2>File Upload</h2>
                  </v-col>
                </v-row>
                <v-row style="gap: 3rem">
                  <v-col
                    cols="3"
                  >
                    <template v-if="viewFirstUpload">
                      <v-row>
                        <p class="gray--text font-weight-bold ma-auto mb-3">
                          {{ firstUploadField }}
                        </p>
                      </v-row>
                      <template v-if="firstUploadField === 'Adjudication'">
                        <v-row>
                          <v-col>
                            <v-file-input
                              v-model="formItem.adjudicationFileUpload"
                              prepend-icon="mdi-file"
                              color="primary"
                              outlined
                              disabled
                            >
                              <template v-slot:selection="{ text, file }">
                                {{ text || file.originalname }}
                              </template>
                            </v-file-input>
                          </v-col>
                          <v-btn
                            icon
                            color="primary"
                            class="mt-4"
                            @click="download(`attachment/fbner/${$route.params.id}`, formItem.adjudicationFileUpload)"
                          >
                            <v-icon size="28">
                              mdi-download
                            </v-icon>
                          </v-btn>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-row>
                          <v-col>
                            <v-file-input
                              v-model="formItem.investigationFileUpload"
                              prepend-icon="mdi-file"
                              color="primary"
                              outlined
                              disabled
                            >
                              <template v-slot:selection="{ text, file }">
                                {{ text || file.originalname }}
                              </template>
                            </v-file-input>
                          </v-col>
                          <v-btn
                            icon
                            color="primary"
                            class="mt-4"
                            @click="download(`attachment/fbner/${$route.params.id}`, formItem.investigationFileUpload)"
                          >
                            <v-icon size="28">
                              mdi-download
                            </v-icon>
                          </v-btn>
                        </v-row>
                      </template>
                    </template>
                  </v-col>
                  <v-col
                    cols="3"
                  >
                    <template
                      v-if="currentStatus.value === 'For Enforcement' ||
                        (formItem.investigationFileUpload.size && currentStatus.value === 'For Adjudication') || currentStatus.value === 'Closed'"
                    >
                      <template v-if="viewSecondUpload">
                        <v-row>
                          <p class="gray--text font-weight-bold ma-auto mb-3">
                            {{ secondUploadField }}
                          </p>
                        </v-row>
                        <template v-if="secondUploadField === 'Adjudication'">
                          <v-row>
                            <v-col>
                              <v-file-input
                                v-model="formItem.adjudicationFileUpload "
                                prepend-icon="mdi-file"
                                color="primary"
                                outlined
                                disabled
                              >
                                <template v-slot:selection="{ text, file }">
                                  {{ text || file.originalname }}
                                </template>
                              </v-file-input>
                            </v-col>

                            <v-btn
                              icon
                              color="primary"
                              class="mt-4"
                              @click="download(`attachment/fbner/${$route.params.id}`,formItem.adjudicationFileUpload)"
                            >
                              <v-icon size="28">
                                mdi-download
                              </v-icon>
                            </v-btn>
                          </v-row>
                        </template>
                        <template v-else>
                          <v-row>
                            <v-col>
                              <v-file-input
                                v-model="formItem.enforcementFileUpload"
                                prepend-icon="mdi-file"
                                color="primary"
                                outlined
                                disabled
                              >
                                <template v-slot:selection="{ text, file }">
                                  {{ text || file.originalname }}
                                </template>
                              </v-file-input>
                            </v-col>

                            <v-btn
                              icon
                              color="primary"
                              class="mt-4"
                              @click="download(`attachment/fbner/${$route.params.id}`,formItem.enforcementFileUpload)"
                            >
                              <v-icon size="28">
                                mdi-download
                              </v-icon>
                            </v-btn>
                          </v-row>
                        </template>
                      </template>
                    </template>
                  </v-col>
                  <v-col
                    cols="3"
                  >
                    <template v-if="secondUploadField === 'Adjudication' && (currentStatus.value === 'For Enforcement' || currentStatus.value === 'Closed')">
                      <template v-if="viewThirdUpload">
                        <v-row>
                          <p class="gray--text font-weight-bold ma-auto mb-3">
                            Enforcement
                          </p>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-file-input
                              v-model="formItem.enforcementFileUpload"
                              prepend-icon="mdi-file"
                              color="primary"
                              outlined
                              disabled
                            >
                              <template v-slot:selection="{ text, file }">
                                {{ text || file.originalname }}
                              </template>
                            </v-file-input>
                          </v-col>
                          <v-btn
                            icon
                            color="primary"
                            class="mt-4"
                            @click="download(`attachment/fbner/${$route.params.id}`, formItem.enforcementFileUpload)"
                          >
                            <v-icon size="28">
                              mdi-download
                            </v-icon>
                          </v-btn>
                        </v-row>
                      </template>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </template>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import fbnerMixin from '@/mixins/fbnerMixin'
export default {
  name: 'FBNERView',
  mixins: [
    fbnerMixin
  ],
  data: () => ({
    selected: ['SEC 25. Unauthorized   Processing of Personal Information and Sensitive Personal Information'],
    panels: [0, 1, 2, 3, 4, 5, 6, 7]
  }),
  computed: {
    defaultView () {
      return this.roleView === 'default'
    }
  },
  methods: {
    // Converts the old data from String to Array
    referencesValue (value) {
      if (typeof value === 'string') return [value]
      return value
    }
  }
}
</script>

<style scoped>
.cursor >>>  textarea{
  overflow-y: hidden !important;
  cursor: default !important
}
.chips-wrap >>> .v-size--default {
  height: auto !important;
}
.chips-wrap >>> .v-chip__content {
  white-space: normal !important;
}
</style>
